export default {
  "drivers.title": "Sub-drivers",
  "drivers.subtitle": "Manage your laundry's driver accounts and follow their completed tasks",
  "drivers.add": "Add driver",
  "drivers.scopeNote": "This page is for your laundry's own sub-drivers only. Coverage follows the laundry's coverage automatically.",

  "drivers.table.photo": "Driver",
  "drivers.table.name": "Full name",
  "drivers.table.phone": "Phone number",
  "drivers.table.username": "Username",
  "drivers.table.availability": "Availability",
  "drivers.table.actions": "Actions",

  "drivers.availability.available": "Available",
  "drivers.availability.busy": "Busy",
  "drivers.availability.unavailable": "Unavailable",
  "drivers.account.disabled": "Account disabled",

  "drivers.action.viewDetails": "View details",
  "drivers.action.edit": "Edit data",
  "drivers.action.resetPassword": "Reset password",
  "drivers.action.disable": "Disable account",
  "drivers.action.enable": "Restore activation",
  "drivers.action.delete": "Delete account",

  "drivers.legend.title": "Availability",
  "drivers.legend.text": "Availability comes from the driver's own data and updates automatically while they work.",
  "drivers.legend.available": "Ready to receive tasks",
  "drivers.legend.busy": "Has an active task",
  "drivers.legend.unavailable": "Not ready right now",

  "drivers.empty.title": "No drivers added yet",
  "drivers.empty.text": "Create login accounts for your laundry's drivers",
  "drivers.empty.action": "Add driver",
  "drivers.error": "Could not load drivers",
  "drivers.errorDetail": "Could not load the driver's data",
  "drivers.notFound": "Driver not found",
  "drivers.notFoundBack": "Back to drivers",

  "drivers.form.addTitle": "Add sub-driver",
  "drivers.form.editTitle": "Edit driver data",
  "drivers.form.section.basic": "Basic data",
  "drivers.form.section.documents": "Documents",
  "drivers.form.section.login": "Login credentials",
  "drivers.form.fullName": "Full name",
  "drivers.form.phone": "Phone number",
  "drivers.form.avatar": "Profile photo",
  "drivers.form.nationalId": "National ID or residency photo",
  "drivers.form.license": "Driving license photo",
  "drivers.form.vehicle": "Vehicle photo",
  "drivers.form.username": "Username",
  "drivers.form.password": "Password",
  "drivers.form.showPassword": "Show password",
  "drivers.form.hidePassword": "Hide password",
  "drivers.form.avatarChoose": "Choose photo",
  "drivers.form.avatarReplace": "Replace photo",
  "drivers.form.avatarRemove": "Remove photo",
  "drivers.form.avatarNone": "No photo added",
  "drivers.form.optional": "Optional",
  "drivers.form.uploadHint": "Size and format limits follow the system settings.",
  "drivers.form.noteLogin": "The driver uses the username and password to sign in to the drivers app.",
  "drivers.form.noteNoApproval": "A sub-driver account does not require admin approval.",
  "drivers.form.noteUsernameLocked": "The username cannot be changed after the account is created.",
  "drivers.form.create": "Create driver account",
  "drivers.form.save": "Save changes",
  "drivers.form.cancel": "Cancel",
  "drivers.upload.upload": "Upload file",
  "drivers.upload.replace": "Replace",
  "drivers.upload.remove": "Remove",
  "drivers.upload.noFile": "No file uploaded",

  "drivers.required.fullName": "Full name is required",
  "drivers.required.phone": "Phone number is required",
  "drivers.required.username": "Username is required",
  "drivers.required.password": "Password is required",
  "drivers.invalid.phone": "Enter a valid Saudi number starting with 05",
  "drivers.usernameTaken": "This username is not available, try another one.",
  "drivers.form.errorFix": "Please fix the required fields before saving.",
  "drivers.form.errorSave": "Could not save the data, please try again.",

  "drivers.reset.title": "Reset driver password",
  "drivers.reset.account": "Account",
  "drivers.reset.newPassword": "New password",
  "drivers.reset.note": "The laundry can set a new password without entering the driver's current password.",
  "drivers.reset.strengthNote": "Password strength follows the system settings.",
  "drivers.reset.confirm": "Reset password",
  "drivers.reset.success": "Password has been reset",
  "drivers.reset.error": "Could not reset the password, please try again.",

  "drivers.confirm.disable.title": "Disable driver account?",
  "drivers.confirm.disable.text": "The driver will stop receiving new tasks while the account is disabled.",
  "drivers.confirm.disable.confirm": "Disable account",
  "drivers.confirm.delete.title": "Delete driver account permanently?",
  "drivers.confirm.delete.text": "Do you want to permanently delete this driver's account?",
  "drivers.confirm.delete.confirm": "Delete account",
  "drivers.confirm.cancel": "Cancel",

  "drivers.toast.created": "Driver account created",
  "drivers.toast.updated": "Driver data saved",
  "drivers.toast.disabled": "Driver account disabled",
  "drivers.toast.enabled": "Account activation restored",
  "drivers.toast.deleted": "Driver account deleted",

  "drivers.detail.back": "Back to drivers",
  "drivers.detail.accountSummary": "Account summary",
  "drivers.detail.actions": "Account actions",
  "drivers.detail.documents": "Documents",
  "drivers.detail.documentsNote": "The documents shown are illustrative placeholders only and do not represent real documents.",
  "drivers.detail.document.view": "View document",
  "drivers.detail.document.none": "No document uploaded",
  "drivers.detail.document.title": "View document",
  "drivers.detail.document.demo": "Illustrative placeholder only, not a real document.",
  "drivers.detail.document.unavailable": "No preview is available for this file in the demo mode.",

  "drivers.detail.tasks": "Completed tasks",
  "drivers.detail.tasks.subtitle": "History of completed pickup and delivery tasks",
  "drivers.detail.tasks.empty": "No completed tasks for this driver yet",
  "drivers.detail.tasks.type": "Task type",
  "drivers.detail.tasks.order": "Order number",
  "drivers.detail.tasks.date": "Date & time",
  "drivers.detail.tasks.fee": "Delivery fee",
  "drivers.detail.tasks.note": "Task fees are for display only; sub-driver accounting is handled with the laundry externally.",
  "drivers.detail.tasks.error": "Could not load the task history",

  "drivers.task.pickup": "Pickup",
  "drivers.task.delivery": "Delivery",

  "drivers.detail.disabledNotice": "This account is temporarily disabled and will not receive new tasks until activation is restored.",

  "drivers.demoNote": "This is a preview with demo data."
};